import { apiEndPoint } from "../../statics/config";

export const postChatBotApi = async (message, token, signal) => {
  const response = await fetch(`${apiEndPoint}/client/interact/llm`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: token
    },
    body: JSON.stringify({ message }),
    signal
  });
  if (!response.ok) {
    console.warn("Atlas Compass service returned HTTP", response.status);
    throw new Error(`Chat request failed: ${response.status}`);
  }
  const payload = await response.json();
  if (payload?.IsSucceeded === false) {
    console.warn(
      "Atlas Compass service rejected the request:",
      payload.ResultCode,
      payload.Message,
      payload.Description
    );
    throw new Error("Compass service is unavailable");
  }
  // This client environment wraps successful API data in Data.
  const data = payload?.Data ?? payload?.data ?? payload;
  return { message: data?.message ?? data?.Message };
};
